"use strict";
// (C) 2019-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspace = void 0;
var tslib_1 = require("tslib");
var executionFactory_1 = require("./execution/executionFactory");
var measures_1 = require("./measures");
var styling_1 = require("./styling/styling");
var factory_1 = require("./catalog/factory");
var settings_1 = require("./settings/settings");
var permissions_1 = require("./permissions/permissions");
var insights_1 = require("./insights");
var datasets_1 = require("./datasets");
var dashboards_1 = require("./dashboards");
var users_1 = require("./users");
var dateFilterConfigs_1 = require("./dateFilterConfigs");
var index_1 = require("./attributes/index");
var facts_1 = require("./facts");
var userGroups_1 = require("./userGroups");
var accessControl_1 = require("./accessControl");
var BearWorkspace = /** @class */ (function () {
    function BearWorkspace(authCall, workspace, descriptor) {
        this.authCall = authCall;
        this.workspace = workspace;
        this.descriptor = descriptor;
    }
    BearWorkspace.prototype.getDescriptor = function () {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var project;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this.descriptor) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.authCall(function (sdk) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    return [2 /*return*/, sdk.project.getProject(this.workspace)];
                                });
                            }); })];
                    case 1:
                        project = _c.sent();
                        return [2 /*return*/, {
                                id: this.workspace,
                                description: (_a = project === null || project === void 0 ? void 0 : project.meta.summary) !== null && _a !== void 0 ? _a : "",
                                title: (_b = project === null || project === void 0 ? void 0 : project.meta.title) !== null && _b !== void 0 ? _b : "",
                            }];
                    case 2: return [2 /*return*/, this.descriptor];
                }
            });
        });
    };
    BearWorkspace.prototype.getParentWorkspace = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                // Bear has no workspace parenting
                return [2 /*return*/, undefined];
            });
        });
    };
    BearWorkspace.prototype.attributes = function () {
        return new index_1.BearWorkspaceAttributes(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.execution = function () {
        return new executionFactory_1.BearExecution(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.settings = function () {
        return new settings_1.BearWorkspaceSettings(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.insights = function () {
        return new insights_1.BearWorkspaceInsights(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.dashboards = function () {
        return new dashboards_1.BearWorkspaceDashboards(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.measures = function () {
        return new measures_1.BearWorkspaceMeasures(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.facts = function () {
        return new facts_1.BearWorkspaceFacts(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.styling = function () {
        return new styling_1.BearWorkspaceStyling(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.catalog = function () {
        return new factory_1.BearWorkspaceCatalogFactory(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.datasets = function () {
        return new datasets_1.BearWorkspaceDataSets(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.permissions = function () {
        return new permissions_1.BearWorkspacePermissionsFactory(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.users = function () {
        return new users_1.BearWorkspaceUsersQuery(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.dateFilterConfigs = function () {
        return new dateFilterConfigs_1.BearWorkspaceDateFilterConfigsQuery(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.userGroups = function () {
        return new userGroups_1.BearWorkspaceUserGroupsQuery(this.authCall, this.workspace);
    };
    BearWorkspace.prototype.accessControl = function () {
        return new accessControl_1.BearWorkspaceAccessControlService(this.authCall, this.workspace);
    };
    return BearWorkspace;
}());
exports.BearWorkspace = BearWorkspace;
//# sourceMappingURL=index.js.map